module.exports = __webpack_public_path__ + "static/media/logo-frame.8e8a3e3e.png";